import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faExternalLink } from '@fortawesome/pro-light-svg-icons'
import { faPencil } from '@fortawesome/pro-solid-svg-icons'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'

import Button from 'components/Button'
import InlineEditableString from 'components/InlineEditableString'

import AddSectionLink from 'agency/digital_renderer/components/ProposalSectionWrapper/AddLink'

import ContentHolder from '../../../ui/ContentHolder'
import styles from './styles.scss'

const renderLinks = (externalLinks, deleteLink, editing) => {
  if (externalLinks && externalLinks.length){
    return (
      <div className={styles.links}>
        {externalLinks.map(link => (
          <Button
            color="darkGrey"
            ghost
            href={editing ? null : link.url}
            icon={<FontAwesomeIcon icon={editing ? faTrash : faExternalLink} />}
            key={link.key}
            onClick={editing ? () => deleteLink(link) : null}
            size="medium"
            target="_blank"
            text={editing ? `${link.title} (Delete)` : link.title}
          />
        ))}
      </div>
    )
  }

  return null
}

const ProposalSection = (props) => {
  const {
    campaignProposalSection: { body, title },
    createLink,
    deleteLink,
    deleteSection,
    editing,
    editingProposal,
    externalLinks,
    toggleEdit,
    updateSectionParam,
  } = props

  return (
    <div className={styles.root}>
      <ContentHolder>
        {editingProposal && (
          <div className={styles.actions}>
            <Button
              color="darkLightBorder"
              ghost
              size="small"
              icon={<FontAwesomeIcon icon={editing ? faCheck : faPencil} />}
              onClick={toggleEdit}
              text={editing ? 'Done' : 'Edit'}
            />

            <Button
              color="darkLightBorder"
              ghost
              size="small"
              icon={<FontAwesomeIcon icon={faTrash} />}
              onClick={deleteSection}
              text="Delete"
            />
          </div>
        )}

        <h3>
          <InlineEditableString
            editing={editing}
            value={title}
            render={({ value }) => value}
            renderEdit={({ value }) => (
              <input
                className={styles.inlineInput}
                type="text"
                defaultValue={value}
                onBlur={e => updateSectionParam('title', e.target.value)}
              />
            )}
          />
        </h3>

        <p>
          <InlineEditableString
            editing={editing}
            value={body}
            render={({ value }) => value}
            renderEdit={({ value }) => (
              <textarea
                className={styles.inlineInput}
                type="text"
                defaultValue={value}
                onBlur={e => updateSectionParam('body', e.target.value)}
              />
            )}
          />
        </p>

        {renderLinks(externalLinks, deleteLink, editing)}

        {editing && (
          <AddSectionLink
            createCallback={createLink}
            render={({
              addLink, title: linkTitle, updateValue, url,
            }) => (
              <div className={styles.addSection}>
                <input
                  type="text"
                  placeholder="Link Title"
                  value={linkTitle}
                  onChange={e => updateValue('title', e.target.value)}
                />
                <input
                  type="text"
                  placeholder="e.g. http://www.google.com"
                  value={url}
                  onChange={e => updateValue('url', e.target.value)}
                />
                <Button color="darkLightBorder" ghost size="small" onClick={addLink} text="Add Link" />
              </div>
            )}
          />
        )}
      </ContentHolder>
    </div>
  )
}

ProposalSection.propTypes = {
  campaignProposalSection: PropTypes.object.isRequired,
  createLink: PropTypes.func.isRequired,
  deleteLink: PropTypes.func.isRequired,
  deleteSection: PropTypes.func.isRequired,
  editing: PropTypes.bool,
  editingProposal: PropTypes.bool,
  externalLinks: PropTypes.array.isRequired,
  light: PropTypes.bool,
  toggleEdit: PropTypes.func.isRequired,
  updateSectionParam: PropTypes.func.isRequired,
}

export default ProposalSection
